export default defineNuxtRouteMiddleware(async (to, from) => {
  const userStore = useUserStore()
  const logger = useFrontendLogger()

  if (userStore.user) {
    logger.addMeta('user', userStore.user)
  }

  return
})
